export default __webpack_public_path__ + "static/media/ls_composition2.4e9613fc.jpg";